import { createRouter, createWebHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import("@/views/Login")
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import("@/layout/Profile"),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import("@/views/Home"),
      },
      {
        path: 'setting',
        name: 'Setting',
        component: () => import("@/views/Setting"),
        meta: {
          title: "Setting"
        }
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
